import { useTranslation } from 'react-i18next'

import { usePreviouslyOrderedProducts } from '@entities/Product'

import { useAuth } from '@features/auth'
import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { URL_CATEGORY_PREVIOUSLY_ORDERED } from '@shared/contants'





export default function ProductsPreviouslyOrderedCarousel () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  const { isAuthorized } = useAuth()

  const {
    previouslyOrderedProducts: products,
    loading: loadingOrderedProducts
  } = usePreviouslyOrderedProducts({
    shop_id: shopId,
    page: 1,
    limit: 20
  })

  if (!isAuthorized) {
    return null
  }

  return (
    <ProductCarousel
      link={URL_CATEGORY_PREVIOUSLY_ORDERED}
      title={tp('previouslyOrdered')}
      products={products}
      loading={loadingOrderedProducts}
    />
  )
}